// PKCE, because the authorization code grant is the only one this client
// may use.
//
// Implicit was the alternative and is refused: it returns the token in a
// URL fragment, which puts a credential into browser history and into
// anything that logs a URL. The pool's client is declared with no secret
// (a public client in a browser cannot hold one), so the code exchange
// has nothing to authenticate itself with — the verifier is what does,
// which is exactly what PKCE is for.

const VERIFIER_BYTES = 32

function base64url(bytes: Uint8Array): string {
  let binary = ''
  for (const byte of bytes) binary += String.fromCharCode(byte)
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function randomBase64url(byteLength: number): string {
  const bytes = new Uint8Array(byteLength)
  crypto.getRandomValues(bytes)
  return base64url(bytes)
}

/** A fresh code verifier: the secret half of one login attempt. */
export function createVerifier(): string {
  return randomBase64url(VERIFIER_BYTES)
}

/**
 * A fresh `state`: the CSRF guard on the redirect back.
 *
 * It is checked on return, so an authorization response the client did
 * not ask for is discarded rather than exchanged.
 */
export function createState(): string {
  return randomBase64url(VERIFIER_BYTES)
}

/** The public half of the verifier — S256, which is the only method to offer. */
export async function challengeFor(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
  return base64url(new Uint8Array(digest))
}
